import { RegisterTypes } from './actionTypes';

export const registerUser = (user: any) => {
  console.log("Entro funcion Action")
  return {
    type: RegisterTypes.REGISTER_USER,
    payload: { user },
  };
};

export const registerUserSuccessful = (user: any) => {
  console.log("Entro funcion Action success")
  return {
    type: RegisterTypes.REGISTER_USER_SUCCESSFUL,
    payload: user,
  };
};

export const registerUserFailed = (user: any) => {
  console.log("Entro funcion Action fail")
  return {
    type: RegisterTypes.REGISTER_USER_FAILED,
    payload: user,
  };
};
